import styled from "styled-components";
import { Container } from "../Layout";
import { colors } from "../../theme";
import { media } from "../../helpers/layout";

type Props = {
  imageLoaded: boolean;
  mounted: boolean;
  shadow?: boolean;
  boxFrame?: boolean;
  canvas?: boolean;
  fixedWidth?: number;
  fixedHeight?: number;
};

export const Wrapper = styled(Container)<Props>(
  ({ imageLoaded, mounted, shadow, boxFrame, canvas, fixedWidth, fixedHeight }) => ({
    backgroundColor: imageLoaded && mounted ? colors.snowWhite : "transparent",
    zIndex: 0,
    height: fixedWidth ? `${fixedHeight}px` : "100%",
    width: fixedWidth ? `${fixedWidth}px` : "100%",
    ...(shadow && {
      boxShadow: boxFrame
        ? `8px 8px 3px ${colors.black}25`
        : canvas
        ? `11.5px 3.83px 13.84px 0px #65656580`
        : `3px 3px 3px ${colors.black}25`,

      [`@media ${media.m}`]: {
        boxShadow: boxFrame
          ? `4px 4px 3px ${colors.black}25`
          : canvas
          ? `11.5px 3.83px 13.84px 0px #65656580`
          : `1px 1px 3px ${colors.black}25`,
      },
    }),
  })
);
